import { NgModule } from '@angular/core'
import { I18nConfig, provideConfig } from '@spartacus/core'
import { orderTranslationChunksConfig, orderTranslations } from '@spartacus/order/assets'
import { OrderRootModule } from '@spartacus/order/root'

@NgModule({
  declarations: [],
  imports: [OrderRootModule],
  providers: [
    provideConfig({
      i18n: {
        resources: orderTranslations,
        chunks: orderTranslationChunksConfig
      }
    } as I18nConfig)
  ]
})
export class OrderFeatureModule {}
